import { QuoteDetails } from 'src/app/modules/shared/entities/quote-details.class';

export interface Quote {
  id: string;
  customerId: string;
  expireDate: string;
  leadId: string;
  quoteNumber: string;
  total: string;
  quoteIsExpired?: boolean;
}

export class QuoteListResponse {
  count: number;
  quotes: QuoteDetails[];

  constructor() {
    this.count = 0;
    this.quotes = [];
  }
}
